import { useContext } from 'react'
import { TabsContext } from 'shared/providers/TabsProvider'

/**
 * Used to return the TabsContext to the consumer.
 */
const useTabs = () => {
  const context = useContext(TabsContext)

  if (context == null) {
    throw new Error('useTabs must be called inside TabsProvider')
  }

  return context
}

export default useTabs
